import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grid md:grid-cols-2">
      <div className="hidden md:block relative overflow-hidden bg-foreground">
        <img
          src="https://images.squarespace-cdn.com/content/v1/6a4f709e7a96bf535a14dca8/d77ed689-7688-4c97-a05c-84fb0d211844/IMG_1322.jpg?format=2750w"
          alt="Nat Habitat interior"
          className="h-full w-full object-cover opacity-70"
        />
        <div className="absolute bottom-12 left-12 text-background">
          <p className="font-serif text-4xl font-light tracking-[0.1em]">NAT HABITAT</p>
          <p className="mt-2 text-xs uppercase tracking-[0.25em] text-background/70">Studio Content Management</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <p className="text-xs uppercase tracking-[0.25em] text-accent">Studio Login</p>
          <h1 className="mt-4 font-serif font-light text-4xl">Welcome back.</h1>
          <p className="mt-3 text-sm text-foreground/60">Sign in to manage projects, images and content.</p>

          <div className="mt-10 space-y-6">
            <div>
              <label className="block text-[11px] uppercase tracking-[0.15em] text-muted-foreground mb-2">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-transparent border-b border-border py-2 focus:outline-none focus:border-foreground transition-colors"
              />
            </div>
            <div>
              <label className="block text-[11px] uppercase tracking-[0.15em] text-muted-foreground mb-2">Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-transparent border-b border-border py-2 focus:outline-none focus:border-foreground transition-colors"
              />
            </div>
          </div>

          <button
            data-testid="login-submit"
            disabled={busy}
            className="mt-10 w-full bg-foreground text-background text-xs uppercase tracking-[0.2em] py-4 hover:bg-accent transition-colors duration-500 disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
